export const catchUpHeaderLabel = "HOTx3b";
export default {catchUpHeaderLabel};